export default "__VITE_ASSET__DkmUSftI__"